<template>
    <div class="detail-body">
        <div class="detail-top">
            <backindex :msg="detailMsg"></backindex>
        </div>
        <div class="book-info">
            <div class="info-status">
                <div class="book-img">
                    <img :src="info.img">
                </div>
                <div class="book-status">
                    <div class="book-name">{{info.title}}</div>
                    <div v-if="info.author" class="book-author"><span>{{info.author}} </span><span>● 著</span></div>
                    <div class="has-end"><span>{{info.words>10000?parseInt(info.words/10000)+"万":info.words}}字 </span><span>● {{parseInt(info.is_end)==1?"完结":"连载"}}</span></div>
                    <div class="book-tags" v-if="tags.length>0">
                        <div class="tag-item" v-for="(tag,index) in tags" :key="index">{{tag}}</div>
                    </div>
                </div>
            </div>
            <p class="book-des">
                {{info.abst}}
            </p>
            <div class="book-btn">
                <div class="read-btn" @click="goRead(info.view_book_item_id)">{{$t("read")}}</div>
                <div class="add-btn" v-if="info.is_favs==1" @click="favs(info.id)">{{$t("onShelf")}}</div>
                <div class="add-btn" v-if="info.is_favs==0" @click="favs(info.id)">{{$t("addShelf")}}</div>
            </div>
        </div>
        <!--其他相关  目录 {{$t("cmt")}}  {{$t("guessLike")}}-->
        <div class="book-other">
            <div class="see-catalog" @click="go.goItemList(info.id)">
                <div class="see-left">
                    <div class="left-one">{{$t("chapters")}}</div>
                    <div class="left-two">{{$t("serialize")}}{{info.book_chapter}}{{$t("chapter")}}</div>
                </div>
                <div class="see-right">
                    <updatetime :time="info.update_time"></updatetime>
                    <div class="right-next"></div>
                </div>
            </div>
            <div class="see-comment">
                <div class="comment-title">
                    <div class="comment-fonts">{{$t("cmtList")}}</div>
                    <div class="comment-icon">
                        <img src="../assets/imgs/comment.png" alt="">
                        <span @click="go.goCmt(info.id)">{{$t("cmt")}}</span>
                    </div>
                </div>
                <div class="comment-item" v-for="(item,index) in comment_list" :key="index" v-bind:style="index<3?{display:'block'}:{display:'none'}">
                    <div class="user-photo">
                        <img :src="item.uimg">
                    </div>
                    <div class="user-info">
                        <div class="user-name">{{item.uname}}</div>
                        <div class="comment-time">{{item.add_time_text}}</div>
                        <div class="comment-con">{{item.info}}</div>
                    </div>
                    <div class="zan-area">
                        <img src="../assets/imgs/zan.png" @click="cmtDigg(item.id)">
                        <span>{{item.digg}}</span>
                    </div>
                </div>
                <div class="more-comment" v-if="comment_list.length>3" @click="showMoreCmt">{{$t("clickMore")}}</div>
            </div>
            <div class="you-like">
                <div class="like-title">{{$t("guessLike")}}</div>
                <div class="like-area" >
                    <div class="like-item" v-for="(item,index) in like_list" :key="index">
                        <div class="like-img">
                            <img  @click="goDetail(item.id)" :src="item.img">
                        </div>
                        <p @click="goDetail(item.id)" class="like-name">{{item.title}}</p>
                    </div>
                </div>
            </div>
        </div>
        <pagebottom></pagebottom>
    </div>

</template>

<script>
import backindex from "@/components/common/backindex";
import updatetime from "@/components/common/updatetime";
import pagebottom from "@/components/common/pagebottom";
export default {
  name: "bookdetail",
  components: {
    backindex,
    updatetime,
    pagebottom
  },
  data() {
    return {
      id: this.$route.query.id,
      detailMsg: "书籍详情",
      info: {},
      comment_list: [],
      like_list: [],
      tags: []
    };
  },
  mounted: function() {
    this.getDetail(this.id);
    this.detailMsg=this.$t("detail");
  },
  methods: {
    getDetail(id) {
      this.id = id;
      document.documentElement.scrollTop = 0;
      this.req.bookDetail(id).then(res => {
        if (res.status == 1) {
          this.info = res.data.info;
          this.comment_list = res.data.comment_list;
          this.like_list = res.data.like_list;
          if (this.info.tags && this.info.tags != "") {
            this.tags = this.info.tags.split(",");
          }
        } else {
          //todo
        }
      });
    },
    //显示更多{{$t("cmt")}}
    showMoreCmt() {
      this.go.goCmt(this.id);
    },
    //切换图id
    goDetail(id) {
      this.go.goDetail(id);
      this.getDetail(id);
    },
    //{{$t("read")}},传小说id
    goRead(id) {
      localStorage.setItem("bookName", this.info.title);
      this.go.goRead(id);
    },
    favs(id) {
      this.req.favs(id).then(res => {
        if(res){
          this.info.is_favs = this.info.is_favs == 1 ? 0 : 1;
          this.$toast({
              message: res.result,
              duration: 1000
            });
        }
      });
    },
    //点赞
    cmtDigg(id) {
      this.req.cmtDigg(id).then(res => {
        for (var i = 0; i < this.comment_list.length; i++) {
          if (this.comment_list[i].id == id) {
            this.comment_list[i].digg = res.data.data;
            break;
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.detail-body {
  width: 100%;
  height: auto;
  background: #f2f2f2;
}
.detail-top {
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
}
/*书籍信息*/
.book-info {
  width: 100%;
  height: auto;
  background: #fff;
  padding: 0.4rem;
  box-sizing: border-box;
  margin: 1.12rem 0 0.16rem;
}
.info-status {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
}
.book-img {
  width: 1.8rem;
  height: 2.54rem;
  overflow: hidden;
}
.book-img img {
  height: 2.54rem;
}
.book-status {
  width: 4.5rem;
  height: auto;
}
.book-name {
  font-size: 0.32rem;
  line-height: 0.32rem;
  padding: 0.3rem 0;
}
.book-author {
  font-size: 0.26rem;
  line-height: 0.26rem;
  padding-bottom: 0.2rem;
  color: #808080;
}
.book-author span:last-child {
  color: #ff1f4f;
}
.has-end {
  font-size: 0.26rem;
  line-height: 0.26rem;
  padding-bottom: 0.2rem;
  color: #808080;
}
.has-end span:last-child {
  color: #ff1f4f;
}
.book-tags {
  display: flex;
}
.tag-item {
  font-size: 0.2rem;
  line-height: 0.2rem;
  padding: 0.08rem 0.12rem;
  border: 0.01rem solid #808080;
  color: #808080;
  margin-right: 0.2rem;
  margin-left: 0; 
  border-radius: 0.04rem;
}
.book-des {
  width: 100%;
  padding: 0.38rem 0 0 0;
  font-size: 0.24rem;
  line-height: 0.4rem;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  height: 5em;
  margin-bottom: 0.4rem;
}
.book-btn {
  display: flex;
  justify-content: space-between;
}
.read-btn,
.add-btn {
  width: 3.2rem;
  height: 0.64rem;
  border-radius: 0.06rem;
  font-size: 0.26rem;
  line-height: 0.64rem;
  text-align: center;
  box-sizing: border-box;
  font-weight: 700;
}
.read-btn {
  background: #ff1f4f;
  color: #fff;
}
.add-btn {
  border: 0.01rem solid #ff1f4f;
  color: #ff1f4f;
}
/*其他相关*/
.book-other {
  width: 100%;
  height: auto;
  background: #ffffff;
}
.see-catalog {
  width: 100%;
  height: 1.13rem;
  box-sizing: border-box;
  border: 0.01rem solid #e6e6e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0.4rem;
}
.see-left,
.see-right {
  display: flex;
  align-items: center;
}
.left-one {
  font-size: 0.3rem;
  line-height: 0.3rem;
  padding-right: 0.2rem;
}
.left-two {
  font-size: 0.2rem;
  line-height: 0.2rem;
  color: #4d4d4d;
}
.right-time {
  font-size: 0.2rem;
  line-height: 0.2rem;
  padding-right: 0.12rem;
}
.right-next {
  width: 0.2rem;
  height: 0.32rem;
  background: url("../assets/imgs/next.png") no-repeat center/cover;
}
/*{{$t("cmt")}}*/
.see-comment {
  width: 100%;
  height: auto;
  padding: 0.4rem;
  border-bottom: 0.02rem solid #f2f2f2;
  box-sizing: border-box;
}
.comment-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.comment-fonts {
  font-size: 0.3rem;
  line-height: 0.3rem;
}
.comment-icon {
  display: flex;
  align-items: center;
  font-size: 0.2rem;
  color: #ff1f4f;
}
.comment-icon img {
  display: block;
  width: 0.32rem;
  height: 0.28rem;
}
.comment-icon span {
  padding-left: 0.1rem;
}
.comment-item {
  width: 100%;
  height: auto;
  padding: 0.6rem 0 0.4rem;
  border-bottom: 0.02rem solid #f2f2f2;
  overflow: hidden;
}
.user-photo {
  width: 0.64rem;
  height: 0.64rem;
  border-radius: 50%;
  overflow: hidden;
  float: left;
}
.user-photo img {
  display: block;
  width: 0.64rem;
  height: 0.64rem;
  border-radius: 50%;
}
.user-info {
  padding-left: 0.4rem;
  float: left;
  width: 5.6rem;
}
.user-name,
.comment-time {
  font-size: 0.2rem;
  line-height: 0.2rem;
  color: #4d4d4d;
}
.user-name {
  padding-bottom: 0.16rem;
}
.comment-time {
  padding-bottom: 0.2rem;
}
.comment-con {
  font-size: 0.2rem;
  line-height: 0.3rem;
  color: #000000;
}
.zan-area {
  float: right;
  font-size: 0.2rem;
  color: #474443;
  display: flex;
  align-items: center;
}
.zan-area img {
  width: 0.32rem;
  height: 0.32rem;
  display: block;
}
.zan-area span {
  padding-left: 0.1rem;
}
.more-comment {
  width: 100%;
  font-size: 0.3rem;
  line-height: 0.3rem;
  padding: 0.4rem 0;
  text-align: center;
  color: #ff1f4f;
}
/*{{$t("guessLike")}}*/
.you-like {
  width: 100%;
  height: auto;
  padding: 0 0.4rem 0.96rem 0.4rem;
  box-sizing: border-box;
}
.like-title {
  font-size: 0.3rem;
  line-height: 0.3rem;
  padding: 0.4rem 0;
}
.like-area {
  width: 100%;
  height: auto;
  overflow: hidden;
}
.like-item {
  width: 1.82rem;
  height: auto;
  float: left;
  margin-right: 0.62rem;
}
.like-item:nth-child(3n) {
  margin-right: 0;
}
.like-img {
  width: 1.82rem;
  height: 2.56rem;
  overflow: hidden;
}
.like-img img {
  height: 2.56rem;
  display: block;
}
.like-name {
  width: 1.82rem;
  font-size: 0.26rem;
  padding-top: 0.22rem;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/bookdetail.vue